import FredAddressBookContactOptionRenderer from './FredAddressBookContactOption';

export default FredAddressBookContactOptionRenderer;